<template>
  <div class="comment-approval">
    <h1>评论审批管理</h1>
    <el-table :data="pendingComments" style="width: 100%">
      <el-table-column prop="id" label="评论ID" width="120" />
      <el-table-column prop="professor_id" label="导师ID" width="120" />
      <el-table-column prop="user_id" label="用户ID" />
      <el-table-column prop="rating" label="评分" width="80" />
      <el-table-column prop="voice_volume" label="声音音量" />
      <el-table-column prop="academic_level" label="学术水平" />
      <el-table-column prop="research_funds" label="科研经费" />
      <el-table-column prop="student_allowance" label="学生补贴" />
      <el-table-column prop="teacher_student_relationship" label="师生关系" />
      <el-table-column prop="work_hours" label="工作时长" />
      <el-table-column prop="student_prospects" label="学生前景" />
      <el-table-column prop="created_at" label="创建时间" />
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="success" @click="approveComment(scope.row.id)">通过</el-button>
          <el-button type="danger" @click="rejectComment(scope.row.id)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import {API_BASE_URL} from "@/config";

export default {
  data() {
    return {
      pendingComments: []
    };
  },
  mounted() {
    this.fetchPendingComments();
  },
  methods: {
    // 获取待审核评论列表
    async fetchPendingComments() {
      const token = localStorage.getItem('access.halfpanda');
      try {
        const response = await axios.get(`${API_BASE_URL}/admin/comment-pending`, {
          headers: {
            'Authorization': token  // 直接使用token，不加Bearer前缀
          }
        })
        if (response.data.code === 200) {
          this.pendingComments = response.data.data;
        } else {
          this.$message.error('获取待审核评论失败');
        }
      } catch (error) {
        console.error('获取待审核评论时出错:', error);
        this.$message.error('获取待审核评论失败');
      }
    },
    // 批准评论
    async approveComment(commentId) {
      try {
        const token = localStorage.getItem('access.halfpanda');
        // 创建 FormData 对象
        const formData = new FormData();
        formData.append('comment_id', commentId);
        formData.append('status', 'approved');

        const response = await axios.post(`${API_BASE_URL}/admin/comment-approve`, formData, {
          headers: {
            'Authorization': token  // 直接使用token，不加Bearer前缀
          }
        });
        if (response.data.code === 200) {
          this.$message.success('评论审核通过');
          await this.fetchPendingComments(); // 重新获取待审核评论列表
        } else {
          this.$message.error('评论审核失败');
        }
      } catch (error) {
        console.error('批准评论时出错:', error);
        this.$message.error('评论审核失败');
      }
    },
    // 拒绝评论
    async rejectComment(commentId) {
      try {
        const token = localStorage.getItem('access.halfpanda');

        // 创建 FormData 对象
        const formData = new FormData();
        formData.append('comment_id', commentId);
        formData.append('status', 'rejected');

        const response = await axios.post(`${API_BASE_URL}/admin/comment-approve`, formData,{
          headers: {
            'Authorization': token  // 直接使用token，不加Bearer前缀
          }
        });
        if (response.data.code === 200) {
          this.$message.success('评论已拒绝');
          await this.fetchPendingComments(); // 重新获取待审核评论列表
        } else {
          this.$message.error('评论审核失败111');
        }
      } catch (error) {
        console.error('拒绝评论时出错:', error);
        this.$message.error('评论审核失败222');
      }
    }
  }
};
</script>

<style scoped>
.comment-approval {
  padding: 20px;
}
</style>